<template>
    <div>
        <!-- 功能按钮 -->
        <buttonlist
                @help="help"
                @add="add"
                @reflash="reflash"
                @del="batchDel"
				ref="SetBtn"
        ></buttonlist>
        <!-- 功能按钮 -->
        <!-- 表格 -->
        <el-table
                id="xpane-0"
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="false"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight"
                @cell-dblclick="editInfo"
                tab-click="selectInfo(0)"
                header-row-class-name="headerclass"
                @selection-change="handleSelectionChange"
                style="width: 100%; margin-top:0px"
                :header-cell-style="$limits.headerClass"
                ref="singleTable"
        >
            <el-table-column type="selection"></el-table-column>
            <el-table-column show-overflow-tooltip prop="shop_position_code" :label="$t('getapi[4832]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="shop_position_name" :label="$t('getapi[3471]')"></el-table-column>
            <el-table-column prop="pos_type" :label="$t('getapi[3475]')">
                <template slot-scope="scope">
                    <span>{{exppostype(scope.row.pos_type)}}</span>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="workcenter_code" :label="$t('getapi[3476]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pos_region" :label="$t('getapi[3477]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Create_Person" :label="$t('getapi[410]')"></el-table-column>
            <el-table-column prop="Create_Time" :label="$t('getapi[135]')">
                <template slot-scope="scope">
                    {{scope.row.Create_Time | toDate}}
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="Modify_Person" :label="$t('getapi[733]')"></el-table-column>
            <el-table-column prop="Modify_Time" :label="$t('getapi[1210]')">
                <template slot-scope="scope">
                    {{scope.row.Modify_Time | toDate}}
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')"></el-table-column>
            <el-table-column prop="sp_flag" :label="$t('getapi[2722]')">
                <template slot-scope="scope">
                    <span>{{expspflag(scope.row.sp_flag)}}</span>
                </template>
            </el-table-column>
            <el-table-column fixed="right" :label="$t('getapi[6048]')" width="80">
                <template slot-scope="scope">
                    <el-button :disabled="!btn.edit" @click.native.prevent="editInfo(scope.row)" type="text" size="small">{{ $t('getapi[34]') }}
                    </el-button>
                    <el-popconfirm
                            :confirmButtonText="$t('getapi[937]')"
                            :cancelButtonText="$t('getapi[6]')"
                            icon="el-icon-info"
                            iconColor="red"
                            :title="$t('getapi[637]')"
                            @onConfirm="del(scope)"
                    >
                        <el-button :disabled="!btn.del" slot="reference" type="text" size="small">{{ $t('getapi[40]') }}</el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
        <!-- 编辑弹框 -->
        <el-dialog v-dialogDrag :visible.sync="isVisible" :title="$t('getapi[34]')" width="35%" :close-on-click-modal="false">
            <el-divider></el-divider>
			<div :style="{border:'1px solid #DCDFE6'}">
			<table>
                <tr>
					<td>{{$t('getapi[4832]')}}</td>
					<td><el-input v-model="dataList._shop_position_code" type="text" size="mini" ></el-input></td>
                    <td>{{$t('getapi[3471]')}}</td>
					<td><el-input v-model="dataList._shop_position_name" type="text" size="mini"></el-input></td>
                </tr>
                <tr>
					<td>{{$t('getapi[3475]')}}</td>
					<td>
                        <el-select filterable v-model="dataList._pos_type" size="mini">
                            <el-option key="+" :label="$t('getapi[3484]')" value='+'></el-option>
                            <el-option key="-" :label="$t('getapi[3485]')" value='-'></el-option>
                            <el-option key="*" :label="$t('getapi[2406]')" value='*'></el-option>
                        </el-select>
                    </td>
                    <td>{{$t('getapi[3476]')}}</td>
					<td>
                        <routejump :urlNo="15" :isDialog="1" @callback="beforeRoutJump">
                        <el-input
                                v-model="dataList._workcenter_code"
                                type="text"
                                readonly
                                size="mini"
                                class="mcolor"
                                :placeholder="$t('getapi[3476]')"
                        >
                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectworkcenter"></i>
                        </el-input>
                        </routejump>
                    </td>
                </tr>
                <tr>
					<td>{{$t('getapi[3477]')}}</td>
					<td><el-input v-model="dataList._pos_region" type="text" size="mini" ></el-input></td>
                    <td>{{$t('getapi[2722]')}}</td>
					<td>
                        <el-select filterable v-model="dataList._sp_flag" size="mini" :disabled="dataList._workcenter_code != ''">
                            <el-option key="0" :label="$t('getapi[2406]')" :value=0></el-option>
                            <el-option key="1" :label="$t('getapi[3472]')" :value=1></el-option>
                            <el-option key="2" :label="$t('getapi[3473]')" :value=2></el-option>
                        </el-select>
                    </td>
                    </tr>
				<tr>
                    <td>{{$t('getapi[410]')}}</td>
					<td><el-input v-model="dataList._create_person" type="text" size="mini" :disabled="true"></el-input></td>
					<td>{{$t('getapi[135]')}}</td>
					<td><el-input v-model="dataList._create_time" type="text" size="mini" :disabled="true"></el-input></td>
                   </tr>
				<tr>
                    <td>{{$t('getapi[733]')}}</td>
					<td><el-input v-model="dataList._modify_person" type="text" size="mini" :disabled="true"></el-input></td>
					<td>{{$t('getapi[1210]')}}</td>
					<td><el-input v-model="dataList._modify_time" type="text" size="mini" :disabled="true"></el-input></td>
                </tr>
				<tr>
                    <td>{{$t('getapi[143]')}}</td>
					<td><el-input v-model="dataList._remark" type="text" size="mini" ></el-input></td>
				</tr>
			</table>
			</div>
			<el-divider></el-divider>

            <span slot="footer" class="dialog-footer">
				<el-button size="small" @click="isVisible = false">{{ $t('getapi[6]') }}</el-button>
				<el-button size="small" type="primary" @click="save" :loading="loading"
                           :disabled="loading">{{ $t('getapi[937]') }}</el-button>
			</span>
        </el-dialog>

        <!--工作中心-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Basic/Popup/GetWorkCenterDataList'" @callback="getworkcenter" ref="workcenter"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';

    export default {
		name: 'proshopposition',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                isVisible: false,
                DbTbNames: '', //表名
                userData: [],
                user: "",
                dataSet: [],
                dataList: {},
                oldDataList:[],
                PageIndex: 1,
                PageSize: 50,
                SelectIndex: 1,
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                queryData: [], // 查询数组
                selectIDData: [],
                ids: "",
				btn: {
					del: false,
					edit: false
				},
                scrollTop:0,
            };
        },
        create() {
        },
        beforeMount() {
            console.log('beforeMount');
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted() {
            let that = this;
            that.userData = JSON.parse(sessionStorage.getItem('userData'))
            that.user = that.userData.username
            that.getView();
			that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[1120]"),this.$t("getapi[11]"));
            },
			//按钮操作权限
			authority() {
				let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
				//只读权
				if (that.$limits.ReadOnlyRights('plv2', 162, 1)) {
					that.$refs.SetBtn.SetButtonEnable('refresh');
				}
				//操作权
				let ilimits = that.$limits.UnOperationAuthority('plv2', 162, 1);
				// limits说明：、2 编辑权限、3 删除权限
				switch (ilimits) {
					case 2:
						that.btn.edit = true;
						that.btn.del = false;
						that.$refs.SetBtn.SetButtonEnable('create,save,refresh');
						break;
					case 3:
						that.btn.edit = true;
						that.btn.del = true;
						that.$refs.SetBtn.SetButtonEnable('create,save,refresh,del');
						break;
					default:
                        that.$refs.SetBtn.SetButtonEnable('');
						break;
				}
			},
            //修改页数
            handleSizeChange(val) {
                this.PageSize = val;
                this.intidata();
				this.authority();
            },
            //跳页
            handleCurrentChange(val) {
                this.PageIndex = val;
                this.intidata();
				this.authority();
            },
            //编辑
            editInfo(row) {
                let that = this;
                console.log(row)
                that.isVisible = true
                that.dataList = {
                    '<IsEdit>k__BackingField': 0,
                    _shop_position_code: row.shop_position_code,
                    _shop_position_name: row.shop_position_name,
                    _pos_type: row.pos_type,
                    _workcenter_code: row.workcenter_code,
                    _create_person: row.Create_Person,
                    _create_time: row.Create_Time,
                    _modify_person: row.Modify_Person,
                    _modify_time: row.Modify_Time,
                    _pos_region: row.pos_region,
                    _remark: row.remark,
                    _sp_flag: row.sp_flag
                }
                that.oldDataList = JSON.stringify(that.dataList)
            },
            // 获取数据
            getView() {
                let that = this;
                that.loading = true;
                that.$http.urlpost('/Basic/Produce/GetShopPositionList', '', function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.DbTbNames = res.DbTbNames;
                    }
                    that.loading = false;
                    that.authority();
                });
            },
            // 保存数据
            save() {
                let that = this;
                if(that.dataList._workcenter_code != '' && that.dataList._sp_flag != 0){
                    that.$message.warning(that.$t('getapi[8611]'))//'标志必须为普通！'
                    return false
                }
                if(that.dataList._workcenter_code == '' && that.dataList._sp_flag == 0){
                    that.$message.warning(that.$t('getapi[3483]'))//标志必须为外协区或半成品区
                    return false
                }
                that.loading = true;
                let parm = new Array();
                parm.push(that.dataList);
                that.$http.urlpost('/Basic/Produce/SaveShopPosition', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[284]'));
                        that.isVisible = false;
                        that.getView();
                    }
                    that.loading = false;
                });
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectIDData = '';
                for (let i = 0; i < val.length; i++) {
                    that.selectIDData += val[i].shop_position_code + ',';
                }
            },
            // 删除
            delf() {
                let that = this;
                let parm = {
                    ids: that.ids
                };
                that.$http.urlpost('/Basic/Produce/DeleteShopPositionByID', parm, function (res) {
                    that.getView();
                    that.$message.success(that.$t('getapi[659]'));
                });
            },
            // 删除
            del(row) {
                this.ids = row.row.shop_position_code + ',';
                this.delf();
            },
            //批量删除
            batchDel() {
                let that = this;
                that.ids = this.selectIDData;
                that.$confirm(that.$t('getapi[8594]'), that.$t('getapi[194]'), {//'此操作将永久删除该数据, 是否继续?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        that.delf();
                    })
                    .catch(() => {
                    });
            },
            // 新增
            add() {
                let that = this
                that.isVisible = true;
                that.dataList = {
                    '<IsEdit>k__BackingField': 1,
                    _shop_position_code: '',
                    _shop_position_name: '',
                    _pos_type: '',
                    _workcenter_code: '',
                    _create_person: '',
                    _create_time: '',
                    _modify_person: '',
                    _modify_time: '',
                    _pos_region: '',
                    _remark: '',
                    _sp_flag: ''
                }
            },
            // 刷新
            reflash() {
                this.getView();
            },
            exppostype(val) {
                if (val == '+') {
                    return this.$t('getapi[3484]')//'待入'
                } else if (val == '-') {
                    return this.$t('getapi[3485]')//待出'
                } else if (val == '*') {
                    return this.$t('getapi[2406]')//'普通'
                } else {
                    return ''
                }
            },
            expspflag(val) {
                if (val == 0) {
                    return this.$t('getapi[2406]')//'普通'
                } else if (val == 1) {
                    return this.$t('getapi[3472]')//'半成品区'
                } else if (val == 2) {
                    return this.$t('getapi[3473]')//'外协区'
                } else {
                    return ''
                }
            },
            //获取工作中心
            selectworkcenter() {
                let that = this;
                that.$refs.workcenter.clearInput(true);
            },
            getworkcenter(data) {
                let that = this
                console.log(data)
                that.dataList._workcenter_code = data.WORKCENTER_CODE
                if(that.dataList._workcenter_code != ''){
                    that.dataList._sp_flag = 0
                }
            },
            beforeRoutJump(val,callback){
                let that = this
                if(that.oldDataList != JSON.stringify(that.dataList)){
                    this.$confirm(that.$t('getapi[12830]'), that.$t('getapi[194]'), {
                        confirmButtonText: that.$t('getapi[1146]'),
                        cancelButtonText: that.$t('getapi[2054]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.isVisible = false
                            callback(true)
                        })
                        .catch(() => {
                            this.$message({
                                type: 'info',
                                message: that.$t('getapi[6096]')
                            });
                        });
                } else {
                    that.isVisible = false
                    callback(true)
                }
            },
        }
    };
</script>

<style lang="scss" scoped>
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
.el-form--inline .el-form-item {
	display: flex;
}

.tb-edit .el-input {
	display: none;
}

.tb-edit .current-row .el-input {
	display: block;
}

.tb-edit .current-row .el-input + span {
	display: none;
}

.el-table .hidden-row {
	display: none;
}
</style>
